export default {
    title: 'Tagesprogramm',
    date: 'Datum',
    addDay: 'Tag hinzufügen',
    alternativelyUploadHighlight: 'PDF-Datei hochladen',
    uploadRequiredHighlight: 'PDF-Datei',
    uploadRequired: 'Bitte laden Sie das Tagesprogramm unten als {highlight} hoch. Es muss für jeden der {duration} Programmtage (siehe Programmdauer) eine Angabe enthalten.',
    alternativelyUpload: 'Alternativ können Sie das Tagesprogramm unten auch als {highlight}. Das hochgeladene Dokument muss für jeden der {duration} Programmtage (siehe Programmdauer) eine Angabe enthalten.',
    changeCausedErrors: 'Durch die Aktion sind Fehler im Tagesprogramm entstanden.',

    morningDescription: 'Vormittag',
    afternoonDescription: 'Nachmittag',
    eveningDescription: 'Abend',
    dateAlreadyExists: 'Das Tagesprogramm für dieses Datum existiert bereits.',
    showListing: 'Details anzeigen',
    hideListing: 'Details ausblenden',
    didHostGroupFullyAttend: 'Nimmt bzw. hat die Gastgebergruppe an dem gesamten Programm teil / teilgenommen?',
    howManyHostGroupMembersAttended: 'Wie viele Personen der Gastgebergruppe sollen ständig anwesend sein bzw. waren ständig anwesend?',
    totalDuration: 'Programmtage',
    noMoreDatesAvailable: 'Es sind keine weiteren Programmtage verfügbar.',
    listing: {
        program: 'Programm',
        morning: 'Vormittag',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        morningHostParticipantsCount: 'TN-Zahl Gastgeber Vormittag',
        afternoonHostParticipantsCount: 'TN-Zahl Gastgeber Nachmittag',
        eveningHostParticipantsCount: 'TN-Zahl Gastgeber Abend',
        hostParticipantsCount: 'TN-Zahl Gastgeber'
    }
}